import {useState} from "react";
import {logEvent} from "../shared/analytics";
import {DOWNLOAD_1099G_INSTRUCTIONS_URL, NJ_UNEMPLOYMENT_URL, SELF_SERVICE_SUBHEADINGS,} from "../shared/constants";
import {DataFetchStatus} from "../shared/types";
import {useTranslation, Trans} from "react-i18next";

function Request1099G() {
  const { t } = useTranslation();
  const [fetchStatus] = useState(DataFetchStatus.Idle);

  return (
    <article>
      <div className="margin-bottom-2 font-sans-xs display-block mobile-lg:display-none">
        {SELF_SERVICE_SUBHEADINGS.REQUEST_1099G}
      </div>

      <div className="option-row margin-bottom-2">
        <div>
          <p className="margin-y-0">
            <Trans i18nKey="selfService.request1099.downloadInstructions" t={t}>
              placeholder_child_0
              <a
                href={`${NJ_UNEMPLOYMENT_URL}/account/tax-forms`}
                className="usa-link usa-link--external blue-override"
                onClick={() => logEvent("Clicked 1099-G download tax forms redirect link")}
              >
                placeholder_child_1
              </a>
            </Trans>
          </p>
        </div>
      </div>

      <div className="option-row">
        <div>
          <p className="margin-y-0">
            <Trans i18nKey="selfService.request1099.learnMore">
              placeholder_child_0
              <a
                href={DOWNLOAD_1099G_INSTRUCTIONS_URL}
                className="usa-link usa-link--external blue-override"
                onClick={() => logEvent("Clicked 1099-G download instructions link")}
              >
                placeholder_child_1
              </a>
            </Trans>
          </p>
        </div>
      </div>
      {fetchStatus === DataFetchStatus.Loading && (
        <div className="loader margin-top-4"></div>
      )}
    </article>
  );
}

export default Request1099G;
